tinymce.addI18n("hu_HU", {
    "#": "#",
    "Accessibility": "Akad\xe1lymentes\xedt\xe9s",
    "Accordion": "Harmonika",
    "Accordion body...": "Harmonika tartalma...",
    "Accordion summary...": "Harmonika \xf6sszegz\xe9se...",
    "Action": "M\u0171velet",
    "Activity": "Tev\xe9kenys\xe9gek",
    "Address": "C\xedm",
    "Advanced": "Speci\xe1lis",
    "Align": "Igaz\xedt\xe1s",
    "Align center": "K\xf6z\xe9pre igaz\xedt\xe1s",
    "Align left": "Balra igaz\xedt\xe1s",
    "Align right": "Jobbra igaz\xedt\xe1s",
    "Alignment": "Igaz\xedt\xe1s",
    "Alignment {0}": "{0} igaz\xedt\xe1sa",
    "All": "Minden",
    "Alternative description": "Alternat\xedv le\xedr\xe1s",
    "Alternative source": "Alternat\xedv forr\xe1s",
    "Alternative source URL": "Alternat\xedv forr\xe1s URL",
    "Anchor": "Horgony",
    "Anchor...": "Horgony...",
    "Anchors": "Horgonyok",
    "Animals and Nature": "\xc1llatok \xe9s term\xe9szet",
    "Arrows": "Nyilak",
    "B": "B",
    "Background color": "H\xe1tt\xe9rsz\xedn",
    "Background color {0}": "H\xe1tt\xe9rsz\xedn {0}",
    "Black": "Fekete",
    "Block": "Blokk",
    "Block {0}": "{0} sz\xf6vegblokk",
    "Blockquote": "Id\xe9zetblokk",
    "Blocks": "Blokkok",
    "Blue": "K\xe9k",
    "Blue component": "K\xe9k komponens",
    "Body": "Sz\xf6vegt\xf6rzs",
    "Bold": "F\xe9lk\xf6v\xe9r",
    "Border": "Szeg\xe9ly",
    "Border color": "Szeg\xe9lysz\xedn",
    "Border style": "Szeg\xe9ly st\xedlusa",
    "Border width": "Szeg\xe9ly vastags\xe1ga",
    "Bottom": "Alulra",
    "Browse files": "Tall\xf3z\xe1s a f\xe1jlok k\xf6z\xf6tt",
    "Browse for an image": "K\xe9p keres\xe9se tall\xf3z\xe1ssal",
    "Browse links": "Tall\xf3z\xe1s a linkek k\xf6z\xf6tt",
    "Bullet list": "Listajeles lista",
    "Cancel": "M\xe9gse",
    "Caption": "Felirat",
    "Cell": "Cella",
    "Cell padding": "Cellamarg\xf3",
    "Cell properties": "Cella tulajdons\xe1gai",
    "Cell spacing": "Cellat\xe1vols\xe1g",
    "Cell styles": "Cellast\xedlusok",
    "Cell type": "Cellat\xedpus",
    "Center": "K\xf6z\xe9pre",
    "Characters": "Karakterek",
    "Characters (no spaces)": "Karakterek (sz\xf3k\xf6z\xf6k n\xe9lk\xfcl)",
    "Circle": "K\xf6r",
    "Class": "Oszt\xe1ly",
    "Clear formatting": "Form\xe1z\xe1s t\xf6rl\xe9se",
    "Close": "Bez\xe1r\xe1s",
    "Code": "K\xf3d",
    "Code sample...": "K\xf3dminta...",
    "Code view": "K\xf3dn\xe9zet",
    "Color Picker": "Sz\xednv\xe1laszt\xf3",
    "Color swatch": "Sz\xednpaletta",
    "Cols": "Oszlopok",
    "Column": "Oszlop",
    "Column clipboard actions": "Oszlop v\xe1g\xf3lapi m\u0171veletek",
    "Column group": "Oszlopcsoport",
    "Column header": "Oszlopfejl\xe9c",
    "Constrain proportions": "M\xe9retar\xe1ny",
    "Copy": "M\xe1sol\xe1s",
    "Copy column": "Oszlop m\xe1sol\xe1sa",
    "Copy row": "Sor m\xe1sol\xe1sa",
    "Could not find the specified string.": "A be\xedrt kifejez\xe9s nem tal\xe1lhat\xf3.",
    "Could not load emojis": "A hangulatjeleket nem siker\xfclt bet\xf6lteni",
    "Count": "Sz\xe1m",
    "Currency": "P\xe9nznem",
    "Current window": "Jelenlegi ablak",
    "Custom color": "Egy\xe9ni sz\xedn",
    "Custom...": "Egy\xe9ni...",
    "Cut": "Kiv\xe1g\xe1s",
    "Cut column": "Oszlop kiv\xe1g\xe1sa",
    "Cut row": "Sor kiv\xe1g\xe1sa",
    "Dark Blue": "S\xf6t\xe9tk\xe9k",
    "Dark Gray": "S\xf6t\xe9tsz\xfcrke",
    "Dark Green": "S\xf6t\xe9tz\xf6ld",
    "Dark Orange": "S\xf6t\xe9t narancss\xe1rga",
    "Dark Purple": "S\xf6t\xe9tlila",
    "Dark Red": "S\xf6t\xe9tv\xf6r\xf6s",
    "Dark Turquoise": "S\xf6t\xe9tt\xfcrkiz",
    "Dark Yellow": "S\xf6t\xe9ts\xe1rga",
    "Dashed": "Szaggatott",
    "Date/time": "D\xe1tum/id\u0151",
    "Decrease indent": "Beh\xfaz\xe1s cs\xf6kkent\xe9se",
    "Default": "Alap\xe9rtelmezett",
    "Delete accordion": "Harmonika t\xf6rl\xe9se",
    "Delete column": "Oszlop t\xf6rl\xe9se",
    "Delete row": "Sor t\xf6rl\xe9se",
    "Delete table": "T\xe1bl\xe1zat t\xf6rl\xe9se",
    "Dimensions": "M\xe9retek",
    "Disc": "Pont",
    "Div": "Div",
    "Document": "Dokumentum",
    "Dotted": "Pontozott",
    "Double": "Dupla",
    "Drop an image here": "H\xfazz ide egy k\xe9pet",
    "Dropped file type is not supported": "Nem t\xe1mogatott f\xe1jlt\xedpus",
    "Edit": "Szerkeszt\xe9s",
    "Embed": "Be\xe1gyaz\xe1s",
    "Emojis": "Hangulatjelek",
    "Emojis...": "Hangulatjelek...",
    "Error": "Hiba",
    "Error: Form submit field collision.": "Hiba: \xdctk\xf6z\xe9s t\xf6rt\xe9nt az \u0171rlap elk\xfcld\xe9sekor.",
    "Error: No form element found.": "Hiba: Nem tal\xe1lhat\xf3 \u0171rlap elem.",
    "Extended Latin": "B\u0151v\xedtett latin",
    "Failed to initialize plugin: {0}": "Nem siker\xfclt el\u0151k\xe9sz\xedteni a be\xe9p\xfcl\u0151 modult: {0}",
    "Failed to load plugin url: {0}": "Nem siker\xfclt bet\xf6lteni a be\xe9p\xfcl\u0151 modul webc\xedm\xe9t: {0}",
    "Failed to load plugin: {0} from url {1}": "Nem siker\xfclt bet\xf6lteni a be\xe9p\xfcl\u0151 modult: {0} err\u0151l a webc\xedmr\u0151l: {1}",
    "Failed to upload image: {0}": "Nem siker\xfclt felt\xf6lteni a k\xe9pet: {0}",
    "File": "F\xe1jl",
    "Find": "Keres\xe9s",
    "Find (if searchreplace plugin activated)": "Keres\xe9s (ha a keres\xe9s \xe9s csere be\xe9p\xfcl\u0151 modul enged\xe9lyezett)",
    "Find and Replace": "Keres\xe9s \xe9s csere",
    "Find and replace...": "Keres\xe9s \xe9s csere...",
    "Find in selection": "Keres\xe9s a kiv\xe1laszt\xe1sban",
    "Find whole words only": "Csak teljes szavak keres\xe9se",
    "Flags": "Z\xe1szl\xf3k",
    "Focus to contextual toolbar": "F\xf3kusz a k\xf6rnyezetf\xfcgg\u0151 eszk\xf6zt\xe1rra",
    "Focus to element path": "F\xf3kusz az elem el\xe9r\xe9si \xfatj\xe1ra",
    "Focus to menubar": "F\xf3kusz a men\xfcre",
    "Focus to toolbar": "F\xf3kusz az eszk\xf6zt\xe1rra",
    "Font": "Bet\u0171t\xedpus",
    "Font size {0}": "{0} bet\u0171m\xe9ret",
    "Font sizes": "Bet\u0171m\xe9ret",
    "Font {0}": "{0} bet\u0171t\xedpus",
    "Fonts": "Bet\u0171t\xedpusok",
    "Food and Drink": "\xc9tel, ital",
    "Footer": "L\xe1bl\xe9c",
    "Format": "Form\xe1tum",
    "Format {0}": "{0} form\xe1tum",
    "Formats": "Form\xe1tumok",
    "Fullscreen": "Teljes k\xe9perny\u0151",
    "G": "G",
    "General": "\xc1ltal\xe1nos",
    "Gray": "Sz\xfcrke",
    "Green": "Z\xf6ld",
    "Green component": "Z\xf6ld komponens",
    "Groove": "Faragott",
    "Handy Shortcuts": "Hasznos billenty\u0171parancsok",
    "Header": "Fejl\xe9c",
    "Header cell": "C\xedmsor cella",
    "Heading 1": "1. c\xedmsor",
    "Heading 2": "2. c\xedmsor",
    "Heading 3": "3. c\xedmsor",
    "Heading 4": "4. c\xedmsor",
    "Heading 5": "5. c\xedmsor",
    "Heading 6": "6. c\xedmsor",
    "Headings": "C\xedmsorok",
    "Height": "Magass\xe1g",
    "Help": "S\xfag\xf3",
    "Hex color code": "Hexadecim\xe1lis sz\xednk\xf3d",
    "Hidden": "Rejtett",
    "Horizontal align": "V\xedzszintes igaz\xedt\xe1s",
    "Horizontal line": "V\xedzszintes vonal",
    "Horizontal space": "T\xe9rk\xf6z v\xedzszintesen",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Az ID bet\u0171vel kezd\u0151dj\xf6n, \xe9s csak bet\u0171ket, sz\xe1mokat, k\xf6t\u0151jelet, pontot, kett\u0151spontot vagy alulvon\xe1st tartalmazzon.",
    "Image is decorative": "Dekor\xe1ci\xf3s k\xe9p",
    "Image list": "K\xe9plista",
    "Image title": "K\xe9p c\xedme",
    "Image...": "K\xe9p...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP hiba: nincs ilyen Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP hiba: helytelen Image Proxy URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP hiba: k\xe9r\xe9s elutas\xedtva",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP hiba: ismeretlen ImageProxy hiba",
    "Increase indent": "Beh\xfaz\xe1s n\xf6vel\xe9se",
    "Inline": "Foly\xf3 sz\xf6veg",
    "Insert": "Besz\xfar\xe1s",
    "Insert Template": "Sablon besz\xfar\xe1sa",
    "Insert accordion": "Harmonika besz\xfar\xe1sa",
    "Insert column after": "Oszlop besz\xfar\xe1sa m\xf6g\xe9",
    "Insert column before": "Oszlop besz\xfar\xe1sa el\xe9",
    "Insert date/time": "D\xe1tum/id\u0151 beilleszt\xe9se",
    "Insert image": "K\xe9p beilleszt\xe9se",
    "Insert link (if link plugin activated)": "Hivatkoz\xe1s besz\xfar\xe1sa (ha a hivatkoz\xe1s be\xe9p\xfcl\u0151 modul enged\xe9lyezett)",
    "Insert row after": "Sor besz\xfar\xe1sa m\xf6g\xe9",
    "Insert row before": "Sor besz\xfar\xe1sa el\xe9",
    "Insert table": "T\xe1bl\xe1zat beilleszt\xe9se",
    "Insert template...": "Sablon besz\xfar\xe1sa...",
    "Insert video": "Vide\xf3 beilleszt\xe9se",
    "Insert/Edit code sample": "K\xf3dminta besz\xfar\xe1sa/szerkeszt\xe9se",
    "Insert/edit image": "K\xe9p beilleszt\xe9se/szerkeszt\xe9se",
    "Insert/edit link": "Hivatkoz\xe1s besz\xfar\xe1sa/szerkeszt\xe9se",
    "Insert/edit media": "M\xe9dia beilleszt\xe9se/szerkeszt\xe9se",
    "Insert/edit video": "Vide\xf3 beilleszt\xe9se/szerkeszt\xe9se",
    "Inset": "S\xfcllyesztett",
    "Invalid hex color code: {0}": "\xc9rv\xe9nytelen hexadecim\xe1lis sz\xednk\xf3d: {0}",
    "Invalid input": "\xc9rv\xe9nytelen bemenet",
    "Italic": "D\u0151lt",
    "Justify": "Sorkiz\xe1rt",
    "Keyboard Navigation": "Billenty\u0171zettel val\xf3 navig\xe1l\xe1s",
    "Language": "Nyelv",
    "Learn more...": "Tudj meg t\xf6bbet...",
    "Left": "Balra",
    "Left to right": "Balr\xf3l jobbra",
    "Light Blue": "Vil\xe1gosk\xe9k",
    "Light Gray": "Vil\xe1gossz\xfcrke",
    "Light Green": "Vil\xe1gosz\xf6ld",
    "Light Purple": "Vil\xe1goslila",
    "Light Red": "Vil\xe1gospiros",
    "Light Yellow": "Vil\xe1goss\xe1rga",
    "Line height": "Line height",
    "Link list": "Hivatkoz\xe1slista",
    "Link...": "Hivatkoz\xe1s...",
    "List Properties": "Lista tulajdons\xe1gai",
    "List properties...": "Lista tulajdons\xe1gai...",
    "Loading emojis...": "Hangulatjelek bet\xf6lt\xe9se...",
    "Loading...": "Bet\xf6lt\xe9s...",
    "Lower Alpha": "Kisbet\u0171s",
    "Lower Greek": "Kisbet\u0171s g\xf6r\xf6g",
    "Lower Roman": "Kisbet\u0171s r\xf3mai sz\xe1mos",
    "Match case": "Kis- \xe9s nagybet\u0171k megk\xfcl\xf6nb\xf6ztet\xe9se",
    "Mathematical": "Matematikai",
    "Media poster (Image URL)": "M\xe9dia poszter (k\xe9p URL)",
    "Media...": "M\xe9dia...",
    "Medium Blue": "Kir\xe1lyk\xe9k",
    "Medium Gray": "K\xf6z\xe9psz\xfcrke",
    "Medium Purple": "K\xf6z\xe9plila",
    "Merge cells": "Cell\xe1k egyes\xedt\xe9se",
    "Middle": "K\xf6z\xe9pre",
    "Midnight Blue": "\xc9jf\xe9lk\xe9k",
    "More...": "Tov\xe1bbiak...",
    "Name": "N\xe9v",
    "Navy Blue": "Tengerk\xe9k",
    "New document": "\xdaj dokumentum",
    "New window": "\xdaj ablak",
    "Next": "K\xf6vetkez\u0151",
    "No": "Nem",
    "No alignment": "Igaz\xedt\xe1s n\xe9lk\xfcl",
    "No color": "Nincs sz\xedn",
    "Nonbreaking space": "Nem t\xf6rhet\u0151 sz\xf3k\xf6z",
    "None": "Nincs",
    "Numbered list": "Sz\xe1mozott lista",
    "OR": "VAGY",
    "Objects": "T\xe1rgyak",
    "Ok": "Rendben",
    "Open help dialog": "S\xfag\xf3ablak megnyit\xe1sa",
    "Open link": "Hivatkoz\xe1s megnyit\xe1sa",
    "Open link in...": "Hivatkoz\xe1s megnyit\xe1sa...",
    "Open popup menu for split buttons": "Felugr\xf3 men\xfc megnyit\xe1sa az osztott gombokhoz",
    "Orange": "Narancss\xe1rga",
    "Outset": "Kiemelt",
    "Page break": "Oldalt\xf6r\xe9s",
    "Paragraph": "Bekezd\xe9s",
    "Paste": "Beilleszt\xe9s",
    "Paste as text": "Beilleszt\xe9s sz\xf6vegk\xe9nt",
    "Paste column after": "Oszlop besz\xfar\xe1sa ut\xe1na",
    "Paste column before": "Oszlop besz\xfar\xe1sa el\xe9",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Beilleszt\xe9s form\xe1zatlan sz\xf6vegk\xe9nt. A tartalom mostant\xf3l form\xe1zatlan sz\xf6vegk\xe9nt lesz beillesztve, am\xedg nem kapcsolod ki ezt az opci\xf3t.",
    "Paste or type a link": "Hivatkoz\xe1s be\xedr\xe1sa vagy beilleszt\xe9se",
    "Paste row after": "Sor besz\xfar\xe1sa ut\xe1na",
    "Paste row before": "Sor beilleszt\xe9se el\xe9",
    "Paste your embed code below:": "Illeszd be a be\xe1gyaz\xe1si k\xf3dot al\xe1bb:",
    "People": "Emberek",
    "Plugins": "Be\xe9p\xfcl\u0151 modulok",
    "Plugins installed ({0}):": "Telep\xedtett be\xe9p\xfcl\u0151 modulok ({0}):",
    "Powered by {0}": "Szolg\xe1ltat\xf3: {0}",
    "Pre": "Pre",
    "Preferences": "Be\xe1ll\xedt\xe1sok",
    "Preformatted": "El\u0151form\xe1zott",
    "Premium plugins:": "Pr\xe9mium be\xe9p\xfcl\u0151 modulok:",
    "Press the Up and Down arrow keys to resize the editor.": "Nyomja meg a fel \xe9s a le ny\xedlgombot a szerkeszt\u0151 \xe1tm\xe9retez\xe9s\xe9hez.",
    "Press the arrow keys to resize the editor.": "Nyomja meg a ny\xedlgombokat a szerkeszt\u0151 \xe1tm\xe9retez\xe9s\xe9hez.",
    "Press {0} for help": "Seg\xedts\xe9g\xe9rt nyomja meg a(z) {0} gombot",
    "Preview": "El\u0151n\xe9zet",
    "Previous": "El\u0151z\u0151",
    "Print": "Nyomtat\xe1s",
    "Print...": "Nyomtat\xe1s...",
    "Purple": "Lila",
    "Quotations": "Id\xe9z\u0151jelek",
    "R": "R",
    "Range 0 to 255": "0-t\xf3l 255-ig",
    "Red": "Piros",
    "Red component": "Piros komponens",
    "Redo": "\xdajra",
    "Remove": "Elt\xe1vol\xedt\xe1s",
    "Remove color": "Sz\xedn t\xf6rl\xe9se",
    "Remove link": "Hivatkoz\xe1s t\xf6rl\xe9se",
    "Replace": "Csere",
    "Replace all": "Az \xf6sszes cser\xe9je",
    "Replace with": "Csere erre:",
    "Resize": "\xc1tm\xe9retez\xe9s",
    "Restore last draft": "Utols\xf3 piszkozat vissza\xe1ll\xedt\xe1sa",
    "Reveal or hide additional toolbar items": "Az eszk\xf6zt\xe1r tov\xe1bbi elemeinek megjelen\xedt\xe9se vagy elrejt\xe9se",
    "Rich Text Area": "Szabadsz\xf6veges mez\u0151",
    "Rich Text Area. Press ALT-0 for help.": "Vizu\xe1lis szerkeszt\u0151 ter\xfclet. Nyomjon ALT-0-t a s\xfag\xf3hoz.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Vizu\xe1lis szerkeszt\u0151 ter\xfclet. Nyomjon ALT-F9-et a men\xfch\xf6z. Nyomjon ALT-F10-et az eszk\xf6zt\xe1rhoz. Nyomjon ALT-0-t a s\xfag\xf3hoz",
    "Ridge": "Dombor\xfa",
    "Right": "Jobbra",
    "Right to left": "Jobbr\xf3l balra",
    "Row": "Sor",
    "Row clipboard actions": "Sor v\xe1g\xf3lapi m\u0171veletek",
    "Row group": "Sorcsoport",
    "Row header": "Sorfejl\xe9c",
    "Row properties": "Sor tulajdons\xe1gai",
    "Row type": "Sort\xedpus",
    "Rows": "Sorok",
    "Save": "Ment\xe9s",
    "Save (if save plugin activated)": "Ment\xe9s (ha a ment\xe9s be\xe9p\xfcl\u0151 modul enged\xe9lyezett)",
    "Scope": "Tartom\xe1ny",
    "Search": "Keres\xe9s",
    "Select all": "Minden kijel\xf6l\xe9se",
    "Select...": "V\xe1lasszon...",
    "Selection": "Kiv\xe1laszt\xe1s",
    "Shortcut": "Billenty\u0171kombin\xe1ci\xf3",
    "Show blocks": "Blokkok mutat\xe1sa",
    "Show caption": "Felirat megjelen\xedt\xe9se",
    "Show invisible characters": "L\xe1thatatlan karakterek mutat\xe1sa",
    "Size": "M\xe9ret",
    "Solid": "Szimpla",
    "Source": "Forr\xe1s",
    "Source code": "Forr\xe1sk\xf3d",
    "Special Character": "Speci\xe1lis karakter",
    "Special character...": "Speci\xe1lis karakter...",
    "Split cell": "Cell\xe1k sz\xe9tv\xe1laszt\xe1sa",
    "Square": "N\xe9gyzet",
    "Start list at number": "Lista kezd\xe9se ett\u0151l a sz\xe1mt\xf3l",
    "Strikethrough": "\xc1th\xfazott",
    "Style": "St\xedlus",
    "Subscript": "Als\xf3 index",
    "Superscript": "Fels\u0151 index",
    "Switch to or from fullscreen mode": "Teljes vagy norm\xe1l k\xe9perny\u0151s m\xf3dra v\xe1lt\xe1s",
    "Symbols": "Szimb\xf3lumok",
    "System Font": "Rendszer bet\u0171t\xedpusa",
    "Table": "T\xe1bl\xe1zat",
    "Table caption": "T\xe1bl\xe1zatfelirat",
    "Table properties": "T\xe1bl\xe1zat tulajdons\xe1gai",
    "Table styles": "T\xe1bl\xe1zatst\xedlusok",
    "Template": "Sablon",
    "Templates": "Sablonok",
    "Text": "Sz\xf6veg",
    "Text color": "Sz\xf6veg sz\xedne",
    "Text color {0}": "Sz\xf6vegsz\xedn {0}",
    "Text to display": "Megjelen\xedtend\u0151 sz\xf6veg",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "A megadott URL e-mail-c\xedmnek t\u0171nik. Szeretn\xe9d hozz\xe1adni a sz\xfcks\xe9ges mailto: el\u0151tagot?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "A megadott URL k\xfcls\u0151 c\xedmnek t\u0171nik. Szeretn\xe9d hozz\xe1adni a sz\xfcks\xe9ges http:// el\u0151tagot?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Az URL amit megadt\xe1l k\xfcls\u0151 hivatkoz\xe1s. Szeretn\xe9d https:// el\u0151taggal megnyitni?",
    "Title": "C\xedm",
    "To open the popup, press Shift+Enter": "A felugr\xf3 ablak megnyit\xe1s\xe1hoz nyomja meg a Shift+Enter billenty\u0171t",
    "Toggle accordion": "Harmonika be- \xe9s kikapcsol\xe1sa",
    "Tools": "Eszk\xf6z\xf6k",
    "Top": "Fel\xfclre",
    "Travel and Places": "Utaz\xe1s \xe9s helyek",
    "Turquoise": "T\xfcrkiz",
    "Underline": "Al\xe1h\xfazott",
    "Undo": "Visszavon",
    "Upload": "Felt\xf6lt\xe9s",
    "Uploading image": "K\xe9p felt\xf6lt\xe9se",
    "Upper Alpha": "Nagybet\u0171s",
    "Upper Roman": "Nagybet\u0171s r\xf3mai sz\xe1mos",
    "Url": "Webc\xedm",
    "User Defined": "Felhaszn\xe1l\xf3 \xe1ltal meghat\xe1rozott",
    "Valid": "\xc9rv\xe9nyes",
    "Version": "Verzi\xf3",
    "Vertical align": "F\xfcgg\u0151leges igaz\xedt\xe1s",
    "Vertical space": "T\xe9rk\xf6z f\xfcgg\u0151legesen",
    "View": "N\xe9zet",
    "Visual aids": "Vizu\xe1lis seg\xe9deszk\xf6z\xf6k",
    "Warn": "Figyelmeztet\xe9s",
    "White": "Feh\xe9r",
    "Width": "Sz\xe9less\xe9g",
    "Word count": "Szavak sz\xe1ma",
    "Words": "Szavak",
    "Words: {0}": "Szavak: {0}",
    "Yellow": "S\xe1rga",
    "Yes": "Igen",
    "You are using {0}": "Haszn\xe1latban: {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Nem mentett m\xf3dos\xedt\xe1said vannak, biztosan el akarsz navig\xe1lni?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "A b\xf6ng\xe9sz\u0151d nem t\xe1mogatja a k\xf6zvetlen hozz\xe1f\xe9r\xe9st a v\xe1g\xf3laphoz. K\xe9rlek, haszn\xe1ld a Ctrl+X/C/V billenty\u0171ket.",
    "alignment": "igaz\xedt\xe1s",
    "austral sign": "austral jel",
    "cedi sign": "cedi jel",
    "colon sign": "kett\u0151spont",
    "cruzeiro sign": "cruzeiro jel",
    "currency sign": "valuta jel",
    "dollar sign": "doll\xe1r jel",
    "dong sign": "dong jel",
    "drachma sign": "drachma jel",
    "euro-currency sign": "euro-valuta jel",
    "example": "p\xe9lda",
    "formatting": "form\xe1z\xe1s",
    "french franc sign": "francia frank jel",
    "german penny symbol": "n\xe9met penny jel",
    "guarani sign": "guarani jel",
    "history": "el\u0151zm\xe9nyek",
    "hryvnia sign": "hrivnya jel",
    "indentation": "beh\xfaz\xe1s",
    "indian rupee sign": "r\xfapia jel",
    "kip sign": "kip jel",
    "lira sign": "l\xedra jel",
    "livre tournois sign": "livre tournois jel",
    "manat sign": "manat jel",
    "mill sign": "mill jel",
    "naira sign": "naira jel",
    "new sheqel sign": "\xfaj s\xe9kel jel",
    "nordic mark sign": "\xe9szaki m\xe1rka jel",
    "peseta sign": "peseta jel",
    "peso sign": "peso jel",
    "ruble sign": "rubel jel",
    "rupee sign": "r\xfapia jel",
    "spesmilo sign": "spesmilo jel",
    "styles": "st\xedlusok",
    "tenge sign": "tenge jel",
    "tugrik sign": "tugrik jel",
    "turkish lira sign": "t\xf6r\xf6k l\xedra jel",
    "won sign": "won jel",
    "yen character": "jen karakter",
    "yen/yuan character variant one": "jen/j\xfcan karaktervari\xe1ns",
    "yuan character": "j\xfcan karakter",
    "yuan character, in hong kong and taiwan": "hongkongi \xe9s tajvani j\xfcan karakter",
    "{0} characters": "{0} karakter",
    "{0} columns, {1} rows": "{0} oszlop, {1} sor",
    "{0} words": "{0} sz\xf3"
});